import { useCallback } from "react";
import { AppointmentStatus } from "@scrile/api-provider/dist/api/AppointmentProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/webvideo/UserPublicDataProvider";
import useAuthUser from "../../../../hooks/useAuthUser";
import providers from "../../../../lib/providers";
import { isPerformer } from "../../../../lib/usersHelper";

export default function useController(user: UserPublicData) {
  const { user: authUser } = useAuthUser();

  const getIsHavePastAppointments = useCallback(async () => {
    if (!authUser || isPerformer(authUser)) return false;

    const res = await providers.AppointmentProvider.search({
      consumerId: authUser.id,
      providerId: user.id,
      sort: "START_TIME,DESC",
      status: [AppointmentStatus.NEW, AppointmentStatus.APPROVED],
      startTimeTo: new Date().toISOString(),
      size: 1,
    });

    return res.result.length > 0;
  }, [authUser, user]);

  return {
    getIsHavePastAppointments,
  };
}
